<template>
  <kst-page-edit
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details :userData="userData"/>
    <TransactionSetting :userData="userData"/>
    <Addresses :userAddresses="userAddresses"/>
  </kst-page-edit>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../CliModel.js";
import Services from "../../../services/Api/ClientServices.js";

import Addresses from "./CliE_Addresses.vue";
import Details from "./CliE_Details.vue";
import TransactionSetting from "./CliE_TransactionSetting.vue";

export default {
  components: {
    Addresses,
    Details,
    TransactionSetting
  },
  mixins: [InputPageMixin],
  data: () => ({
    userData: {},
    userAddresses: []
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadEdit) {
      this.resetData();

      const config = Services.getEditData(id);
      loadEdit(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      Model.Edit.setAddressesByData(this.userAddresses, data.Details.AddressList);
      Model.Edit.setDetailsByData(this.userData, data.Details);
    },

    handleSubmit(saveData) {
      let data = Model.populateData(this.userData, this.userAddresses);
      const config = Services.putData(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.userData = Model.createDetails();
      this.userAddresses = [];
    }
  }
}
</script>

<style scoped lang="css" src="./_layout.css"/>